import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Message, MessageService } from "../message";
import { FormsModule, NgForm } from  '@angular/forms';
import { HttpClient } from '@angular/common/http';

import $ from 'jquery'; 

@Component({
  standalone: true,
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css'],
  imports: [
    CommonModule,
    FormsModule
  ]
})

export class ContactFormComponent implements OnInit {
  submitted = false;
  themessage = new Message ("","","","", false); 
  phonefocus = false;
  emailfocus = false;
  namefocus = false;  
  messagefocus = false;
  postId = "";
  successfulsubmit = false;
  
  phonePattern = "^[+]{0,1}[-0-9]{0,7}[ ]{0,1}[(]{0,1}[0-9]{3}[)]{0,1}[ ]{0,1}[-]{0,1}[ ]{0,1}[0-9]{3}[ ]{0,1}[-]{0,1}[ ]{0,1}[0-9]{4}$";
  emailPattern = "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$";
  
  constructor (private messageService: MessageService, private http: HttpClient) {
  }
  
  ngOnInit() {
  }
  
  onFormSubmit(form: NgForm) {
    console.log ("submitted");
    console.log (this);
    var apiURL = "https://eajxzgml00.execute-api.us-west-2.amazonaws.com/daylilycontact/webcontact";
    var invalid = false;
    var resultData;
    var theResult = "";

    this.themessage = form.value;

    this.http.post<any>("https://eajxzgml00.execute-api.us-west-2.amazonaws.com/daylilycontact/webcontact", {
      "url" : apiURL,
      "type": "POST",
      "dataType": "json",
      "crossDomain": true,
      "contentType": "application/json; charset=utf-8",
      data: JSON.stringify(this.themessage)})
    .subscribe(data => {
      this.postId = data.id;
      console.log ("data: ", JSON.stringify(data));
      resultData = JSON.parse(JSON.stringify(data));
      console.log ("resultData: ", resultData);
      theResult = String(resultData["body-json"]["result"]);
      if (theResult == "SUCCESS") {
        this.successfulsubmit = true;
        form.reset();
      } else {
        this.successfulsubmit = false;
        alert ("Internal messaging failure.  Please contact Daylily, darcy@daylilyventura.com.")
      }
    });
  }
}
